/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Applications_FoundInputs */

const en_no_applications_found = /** @type {(inputs: No_Applications_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No applications found for this job position.`)
};

const de_no_applications_found = /** @type {(inputs: No_Applications_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese Stelle wurden keine Bewerbungen gefunden.`)
};

/**
* | output |
* | --- |
* | "No applications found for this job position." |
*
* @param {No_Applications_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_applications_found = /** @type {((inputs?: No_Applications_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Applications_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_applications_found(inputs)
	return en_no_applications_found(inputs)
});